import { isConcurrentNode } from 'components/scenarios/utils/graph/nodes/typeguards'

import type { ScenarioRunGraph } from 'types/api/scenarios/runs/scenario-runs'
import type {
  BaseGraph,
  GraphNode,
  ScenarioGraph
} from 'types/api/scenarios/scenario'

export const walkGraph = function* (graph: BaseGraph, start = graph?.start_id) {
  if (!start) return []

  let next = start
  while (next && graph.nodes[next]) {
    const current = graph.nodes[next]
    next = current?.next
    yield current
  }
}

/**
 * As opposed to the _generator_ function `walkGraph`, this will loop over all nodes of graph
 * (including the branches of concurrent nodes) until the conditionFunc
 * returns false. The idea is to prevent walking the full graph if it isn't necessary to do so.
 */
export function walkGraphUntilCondition(
  graph: ScenarioRunGraph | ScenarioGraph,
  conditionFunc: (node: GraphNode) => boolean
) {
  const { nodes } = graph
  const startId = 'start_id' in graph ? graph.start_id : graph.startId
  const startNode = nodes[startId]

  if (!startNode) return

  let next = startId
  let current: GraphNode | undefined = startNode

  while (next && current && conditionFunc(current)) {
    if (isConcurrentNode(current)) {
      current.branches.forEach((branch) =>
        walkGraphUntilCondition(branch, conditionFunc)
      )
    }
    next = current?.next ?? ''
    current = next ? nodes[next] : undefined
  }
}
